/**
 * @file 开始使用页快速安装
 * @author wanzhongyun
 */
import React from 'react';
import {Select} from 'antd';
import QuickStart from '../../components/quick-start/QuickStart';
import useQuickHooks from './quickHooks';
import DocContainer from '../../components/doc-container/DocContainer';

const Quick: React.FC = () => {
    const {
        quickStartHooks,
        quickInstallDetail,
        language,
        suffixText,

        setLanguage
    } = useQuickHooks();

    return (
        <div className="paddle-install-page-subcontainer">
            <div className="paddle-context-h2">
                Quick Start
            </div>

            <QuickStart
                trackeventOptLabel="Quick Start"
                {...quickStartHooks}
            />
            <div
                className="paddle-install-quick-suffixtext"
                {...{dangerouslySetInnerHTML: {__html: suffixText}}}
            />
            <div className="paddle-install-quick-detail-wrap">
                <div className="paddle-install-quick-lang-select">
                    <Select
                        value={language}
                        onChange={setLanguage}
                        size="large"
                    >
                        <Select.Option key="zh" value="zh">中文(简)</Select.Option>
                        <Select.Option key="en" value="en">English</Select.Option>
                    </Select>
                </div>
                <DocContainer
                    text={quickInstallDetail}
                />
            </div>
        </div>
    );
};

export default Quick;
